/* eslint-disable */
import React from 'react';
import Switch from '@mui/material/Switch';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';

const IsEnabled = styled(Switch)(({ theme, disabled }) => {
  let backgroundColor;
  if (disabled) {
    backgroundColor = '#D3D3D3';
  } else {
    backgroundColor = theme.palette.mode === 'light' ? '#E9E9EA' : '#39393D';
  }

  return {
    cursor: disabled ? 'not-allowed' : 'inherit',
    padding: 8,
    '& .MuiSwitch-track': {
      borderRadius: 22 / 2,
      backgroundColor,
      opacity: 1,
      transition: theme.transitions.create(['background-color'], {
        duration: 500,
      }),
    },
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: 16,
      height: 16,
      margin: 2,
      backgroundColor: disabled ? '#A9A9A9' : '',
    },
    '& .MuiSwitch-switchBase': {
      '&.Mui-checked': {
        color: '#fff',
        '& + .MuiSwitch-track': {
          backgroundColor: disabled ? '#D3D3D3' : '#6B5CE8',
          opacity: 1,
        },
      },
    },
  };
});

const ControlledSwitches = ({
  handleChange,
  checked,
  switchCss,
  disabled = false,
}) => {
  return (
    <>
      {disabled ? (
        <IsEnabled
          disabled={disabled}
          checked={checked}
          onChange={handleChange}
          className={`common-switch ${switchCss}`}
        />
      ) : (
        <IsEnabled
          checked={checked}
          onChange={handleChange}
          className={`common-switch ${switchCss}`}
        />
      )}
    </>
  );
};

ControlledSwitches.propTypes = {
  switchCss: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  disabled: PropTypes.bool,
};

export default ControlledSwitches;
